module.exports = __webpack_public_path__ + "e9c5c58.ttf";